import { getVideoData } from 'utils/video';

type Props = {
  url: string;
};

export function AmpVideoPlayer({ url }: Props) {
  const videoData = getVideoData({ url });
  if (!videoData) return null;

  const VideoComponent = `amp-${videoData.type}`;

  return (
    <VideoComponent
      data-videoid={videoData.videoId}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ "data-videoid": string; layout: string; wi... Remove this comment to see the full error message
      layout="responsive"
      width="480"
      height="270"
    />
  );
}
